import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'
import { Col } from 'reactstrap'
import styled from 'styled-components'

import {
  fetchInteractionsPreview,
  redirectToTicket
} from '../../ducks/interactionsPreview'

import Preloader from '../../components/UI/Preloader'
import InteractionItemMiddle from './InteractionItemMiddle'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;

  margin-top: 20px;
  margin-bottom: 20px;
  padding: 8px;
`

class InteractionsPreviewList extends Component {
  componentDidMount() {
    this.props.fetchInteractionsPreview()
  }

  onInteractionClickHandler = (interactionId, state) => () => {
    this.props.redirectToTicket(interactionId, state)
  }

  renderInteractionsPreview = () => {
    const { interactionsPreview } = this.props
    const { entities } = interactionsPreview

    return entities.map((interaction) => (
      <InteractionItemMiddle
        withPadding={true}
        customPadding={8}
        key={interaction.interaction_id}
        interaction={interaction}
        onClickHandler={this.onInteractionClickHandler(
          interaction.interaction_id,
          interaction.state
        )}
      />
    ))
  }

  render() {
    const { interactionsPreview } = this.props
    const { loading } = interactionsPreview

    return (
      <Col md={12}>
        <Wrapper>
          {loading && <Preloader />}
          {this.renderInteractionsPreview()}
        </Wrapper>
      </Col>
    )
  }
}

export default compose(
  connect(
    ({ interactionsPreview }) => ({
      interactionsPreview
    }),
    { fetchInteractionsPreview, redirectToTicket }
  ),
  withNamespaces(),
  withRouter
)(InteractionsPreviewList)
